import { z } from 'zod/v4';

export const activitiesSchema = z.object({
  viewVehicles: z.boolean(),
  addVehicles: z.boolean(),
  updateVehicles: z.boolean(),
  deleteVehicles: z.boolean(),
  importVehicles: z.boolean(),
  exportVehicles: z.boolean(),
  viewVehicleGroups: z.boolean(),
  addVehicleGroups: z.boolean(),
  updateVehicleGroups: z.boolean(),
  deleteVehicleGroups: z.boolean(),
  viewDrivers: z.boolean(),
  addDrivers: z.boolean(),
  updateDrivers: z.boolean(),
  deleteDrivers: z.boolean(),
  importDrivers: z.boolean(),
  exportDrivers: z.boolean(),
  viewDriverGroups: z.boolean(),
  addDriverGroups: z.boolean(),
  updateDriverGroups: z.boolean(),
  deleteDriverGroups: z.boolean(),
  accessRoutingProfiles: z.boolean(),
  accessConfigurationProfiles: z.boolean(),
  addUsers: z.boolean(),
  editUsers: z.boolean(),
  deleteUsers: z.boolean(),
  importUsers: z.boolean(),
  exportUsers: z.boolean(),
});

export type Activities = z.infer<typeof activitiesSchema>;
